/**
 * ChatProvider — monta o estado do chat (useChat) e provê via contexto.
 * Hook useChatContext fica em useChatContext.ts (Fast Refresh exige arquivos separados).
 */
import React, { ReactNode } from 'react';
import { useChat as useLocalChat } from '../features/chat/hooks/useChat';
import { ChatContext } from './useChatContext';

export function ChatProvider({ children }: { children: ReactNode }) {
    const chatState = useLocalChat();

    return (
        <ChatContext.Provider value={chatState}>
            {children}
        </ChatContext.Provider>
    );
}
